import Vue from "vue";
import Vuex from "vuex";
import FilterModule from "./modules/FilterModule";
import ContentModule from "@/store/modules/ContentModule";
import MemberModule from "@/store/modules/MemberModule";
import PrintBasketModule from "@/store/modules/PrintBasketModule";
import createPersistedState from "vuex-persistedstate";
import SearchModule from "@/store/modules/SearchModule";
import CarModelsModule from "@/store/modules/CarModelsModule";

let persistedPaths: string[] = [];
persistedPaths = persistedPaths.concat(FilterModule.persisted);
persistedPaths = persistedPaths.concat(ContentModule.persisted);
persistedPaths = persistedPaths.concat(MemberModule.persisted);
persistedPaths = persistedPaths.concat(PrintBasketModule.persisted);
persistedPaths = persistedPaths.concat(SearchModule.persisted);

const dataState = createPersistedState({
  key: "TRIP.Modules",
  paths: persistedPaths,
});
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    ContentModule,
    FilterModule,
    MemberModule,
    PrintBasketModule,
    SearchModule,
    CarModelsModule,
  },
  plugins: [dataState],
});
